import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { displayErrorMessage } from 'utils/tools_functions';
import { forgotPassword } from 'services/API/User';
import { useTranslation } from 'react-i18next';

import InputLabel from 'components/generics/InputLabel';
import Button from 'components/generics/Button';

const DEFAULT_FORM = {
  email: '',
  action: localStorage.getItem('action_password') ? localStorage.getItem('action_password') : '',
};

const LoginForm = () => {
  const [formData, setFormData] = useState(DEFAULT_FORM);
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();

  const onSubmit = (e) => {
    if (e) e.preventDefault();
    setLoading(true);
    forgotPassword(i18n.language, formData)
      .then(() => {
        toast.success(t('success.emailSentReset'));
        setLoading(false);
        setFormData(DEFAULT_FORM);
      })
      .catch(() => {
        setLoading(false);
        toast.error(displayErrorMessage('ERR_REINIT_PASSWORD'));
      });
  };

  const updateForm = (key, value) => setFormData({ ...formData, [key]: value });

  return (
    <div>
      <form onSubmit={onSubmit}>
        <InputLabel
          name="email"
          value={formData.email}
          onChange={(e) => {
            updateForm('email', e);
          }}
          placeholder={t('form.email')}
          label={t('form.enterEmail')}
          defaultStyle="login"
          disabled={loading}
        />
        <Button
          defaultStyle="d-block"
          type="submit"
          text={t('button.sendEmail')}
          disabled={loading}
        />
      </form>
    </div>
  );
};

export default LoginForm;
